import {
  AppointmentListActionTypes,
  APPOINTMENT_LIST_FAIL,
  APPOINTMENT_LIST_LOADING,
  APPOINTMENT_LIST_SUCCESS,
  AppointmentListState,
  APPOINTMENT_LIST_UPDATE_API_MSG,
  APPOINTMENT_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { AppointmentListResponse } from "./Model";

const initialStateGetPosts: AppointmentListState = {
  loading: false,
  appointmentListRes: {} as AppointmentListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const allappointmentListReducer = (
  state = initialStateGetPosts,
  action: AppointmentListActionTypes
): AppointmentListState => {
  switch (action.type) {
    case APPOINTMENT_LIST_LOADING:
      return {
        ...state,
        loading: true,
        appointmentListRes: {} as AppointmentListResponse,
      };
    case APPOINTMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        appointmentListRes: action.payload,
        successMsg: action.successMsg,
        status: action.status
      };
    case APPOINTMENT_LIST_FAIL:
      return {
        ...state,
        loading: false,
        appointmentListRes: {} as AppointmentListResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case APPOINTMENT_LIST_UPDATE_API_MSG:
      return {
        ...state,
        loading: false,
        appointmentListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case APPOINTMENT_LIST_UPDATE_API_RES:
      return {
        ...state,
        loading: false,
        appointmentListRes: {} as AppointmentListResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
